export default __webpack_public_path__ + "static/media/03.67e386fa.jpg";